<template>
  <div class="w-full flex flex-col items-center justify-center py-16">
    <myc-spinner />
    <div class="flex flex-col items-center mt-4">
      <div class="text-sm font-medium">
        Please wait
      </div>
      <div class="text-sm text-neutral-500">
        You'll be navigated in seconds...
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import mycSpinner from '@/components/common/myc-spinner.vue';
import { signInWithMagicLink } from '@/modules/user/AuthService';
import { useAuthStore } from '@/stores';

export default {
  name: 'MagicLink',
  components: {
    mycSpinner,
  },
  async mounted() {
    const { token } = this.$route.query;

    if (!token) {
      this.$clyNotify({ message: this.$t('mycountly.errors.magic-link-invalid'), sticky: false, type: 'error' });
      this.$router.push({
        name: 'signin',
      });
      return;
    }

    const signInResponse = await signInWithMagicLink({ token });

    if (signInResponse.isOk()) {
      this.refreshLoggedInUser();

      this.$router.push({
        name: 'Loading',
        query: {
          referrer: 'login',
        },
      });
    } else {
      this.$clyNotify({ message: this.$t('mycountly.errors.magic-link-invalid'), sticky: false, type: 'error' });
      this.$router.push({
        name: 'signin',
      });
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['refreshLoggedInUser']),
  },
};
</script>
